<script setup lang="ts">
import useStatusAnnouncementStore from '~/stores/StatusAnnouncement';
import type { StatusAnnouncementLocation } from '~/typings/enums';

interface Props {
    location: StatusAnnouncementLocation;
}

const props = defineProps<Props>();

const statusAnnouncementStore = useStatusAnnouncementStore();
const feedbackDialog = ref<string>();

</script>

<template>
    <div class="bg-red w-full flex justify-center">
        <div class="flex flex-col justify-start w-full">
            <template v-for="[uuid, announcement] in statusAnnouncementStore.announcements">
                <div
                    v-if="announcement.show_on.includes(props.location)"
                    :key="uuid"
                    class="w-full p-4 flex gap-4 text-white fill-white items-center"
                >
                    <span class="grow-0">
                        <IconTooltip />
                    </span>

                    <span class="grow flex flex-col gap-1 justify-center">
                        <span class="font-bold">{{ announcement.title }}</span>
                        <span>{{ announcement.description }}</span>
                    </span>

                    <span
                        v-if="announcement.allow_feedback"
                        class="grow-0"
                    >
                        <Button
                            theme="outline"
                            color="white"
                            size="xs"
                            @click="feedbackDialog = uuid"
                        >
                            {{ $t('status.add_feedback') }}
                        </Button>
                    </span>
                </div>
            </template>
        </div>
    </div>

    <Dialog
        :model-value="!!feedbackDialog"
        position-close-button="none"
        @update:model-value="feedbackDialog = undefined"
    >
        <StatusFeedbackForm
            v-if="feedbackDialog"
            :status-announcement-uuid="feedbackDialog"
            @created="feedbackDialog = undefined"
            @cancelled="feedbackDialog = undefined"
        />
    </Dialog>
</template>
